import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name:sessionStorage.getItem('name')
  },
  mutations: {
    set_name(state,num){
      state.name = num
    },
  },
  actions: {

  }
})
